import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAppSelector } from 'store/useAppSelector';

import { selectCurrentChargingModel } from '../store/selectors';

export const useChargingModel = () => {
  const { group } = useAccount();
  const { isFreemium } = useAccountStatus();

  const chargingModel = useAppSelector(state =>
    selectCurrentChargingModel(state, group, isFreemium),
  );

  return chargingModel;
};
